import { useState } from 'react';
import loadable from '@loadable/component';

import { Grid, Button } from '@simplywallst/ui-core';

import { Chart } from '../Chart';

import { useNormalisedDiversification } from '../../hooks';

import type { PortfolioAnalysis } from '../../../../hooks/usePortfolioAnalysis';

const OversizedChartModal = loadable(() => import('../OversizedChartModal'), {
  resolveComponent: (c) => c.OversizedChartModal,
});

interface Props {
  diversification: NonNullable<PortfolioAnalysis['diversification']>;
  holdingsCount: number;
}

export const PopulatedState = ({ diversification, holdingsCount }: Props) => {
  const [showOversizedChart, setShowOversizedChart] = useState(false);

  const isPortfolioOversized = holdingsCount > 30;

  const normalisedDiversification = useNormalisedDiversification({
    diversification,
    collapseHoldings: isPortfolioOversized,
  });

  return (
    <Grid gap="24px">
      <Chart
        data={normalisedDiversification}
        holdingsCount={holdingsCount}
        onLabelClick={() => setShowOversizedChart(true)}
      />
      {isPortfolioOversized && (
        <Button
          styleType="loudLarge"
          onClick={() => setShowOversizedChart(true)}
          aria-label="Show Full Chart"
        >
          Show Full Chart
        </Button>
      )}
      {showOversizedChart && (
        <OversizedChartModal
          diversification={diversification}
          holdingsCount={holdingsCount}
          onClose={() => setShowOversizedChart(false)}
        />
      )}
    </Grid>
  );
};
